import React, { useEffect, useMemo, useState } from 'react';
import {
    TextField, FormControl, InputLabel, Grid, Paper, Select, MenuItem,
    useMediaQuery, Button, TextareaAutosize, Table, TableBody, TableCell, TableContainer,
    TableHead, TableRow, Checkbox
} from '@mui/material';
import 'react-toastify/dist/ReactToastify.css';
import { toast, ToastContainer } from 'react-toastify';
import Titlebar from '../TitleBar';
import { materialPOMenu, PurchaseOrdMaster } from '../TitleList';
import styled, { inputImages, inputStyles } from '../../Utils/inputChanges';
import { useDispatch, useSelector } from 'react-redux';
import { getCurrentDate } from '../../Utils/Dateutils';
import { selectCloths, selectFirm, selectParty, selectPoNo } from '../Selectors/Master/ItemSelectors';
import { fetchClothData } from '../../Store/PHPSlice/Cloth';
import { createPOEntry, fetchPoNo } from '../../Store/PHPSlice/Purchase/PoNo';
import { fetchPartyData } from '../../Store/PHPSlice/Party';
import { fetchCompanyData } from '../../Store/PHPSlice/Firm';
import Dropdown from '../FieldsComponents/Dropdown';
import DropdownWithBtn from '../FieldsComponents/DropdownWithBtn';
import CircularProgress from '@mui/material/CircularProgress';
import { fetchMaterialData } from '../../Store/PHPSlice/Material';
import { selectMaterials } from '../Selectors/Master/OutwardSelectors';
import axios from 'axios';


const MaterialPOEntry = () => {
    const userdata = JSON.parse(localStorage.getItem('user'));
    const baseUrl = process.env.REACT_APP_BASE_URL;
    const [formData, setFormData] = useState({
        cloth: '',
        vender: '',
        PoNo: '',
        ordt: getCurrentDate(),
        firm: '',
        tQtyM: '',
        amt: '',
        taxAmt: '',
        fAmt: '',
        shftTo: '',
        ref: '',
        userId: userdata?.ID
    });
    const [tableRows, setTableRows] = useState([]);
    const [selectedRows, setSelectedRows] = useState([]);
    const [openDropdowns, setOpenDropdowns] = useState({});

    const [loading, setLoading] = useState(false);
    const [materialData, setMaterialData] = useState([]);

    const actionMap = {
        cloth: fetchClothData,
        vender: fetchPartyData
        // Add more mappings if needed
    };
    const dispatch = useDispatch();
    const clothList = useSelector(selectCloths);
    const getPoNo = useSelector(selectPoNo);
    const partyList = useSelector(selectParty);
    const firmList = useSelector(selectFirm);
    const materialdata = useSelector(selectMaterials);
    // console.log(materialdata)

    useEffect(() => {
        dispatch(fetchClothData());
        // dispatch(fetchMaterialData());
        dispatch(fetchPoNo());
        fetchPONOMaterial();
        fetchMateriallist();
        dispatch(fetchPartyData());
        dispatch(fetchCompanyData());
        Object.keys(openDropdowns).forEach((dropdown) => {
            if (openDropdowns[dropdown]) {
                const action = actionMap[dropdown];
                if (action) {
                    dispatch(action());
                }
            }
        });
    }, [openDropdowns, dispatch]);


    const fetchPONOMaterial = async () => {
        try {
            const res = await axios.get(`${baseUrl}?apicall=getMaterialPono_api`);
            // console.log(res.data);
            const memo = res.data?.data;
            setFormData((prevFormData) => ({
                ...prevFormData,
                PoNo: memo?.pono
            }));
        } catch (error) {
            console.error(error);
        }
    };

    const fetchMateriallist = async () => {
        try {
            const res = await axios.get(`${baseUrl}?apicall=getMaterialListInfo`);
            // console.log(res.data);
            const data = res.data?.data;
            setMaterialData(data);
        } catch (error) {
            console.error(error);
        }
    };


    const isDesktop = useMediaQuery('(min-width:768px)'); // Adjust the breakpoint as per your requirement

    const handleDropdownChange = (e, dropdownType) => {
        const { value } = e.target;
        setFormData({
            ...formData,
            [dropdownType]: value
        });
        if (dropdownType === 'cloth' && value) {
            const selCloth = clothList?.data?.length > 0 ? clothList?.data?.find((item) => item.ID === value) : [];

            if (selCloth) {
                const { ID, clothNm, uom, hsn, color, model, panna_size, shadeNo } = selCloth;
                handleAddRow(clothNm, uom, hsn, ID, color, model, panna_size, shadeNo);
            }
            setTimeout(() => {
                setFormData({
                    ...formData,
                    cloth: ''
                });
            }, 1000);

        }

        if (dropdownType === 'matId' && value) {
            const selectMat = materialData?.find(i => i.ID === value);
            if (selectMat) {
                // console.log(selectMat);
                const { ID, hsn, description, locId, locNm, materialNm, mtype, ptype, packetqty, mqty, size, totqty } = selectMat;
                handleAddMaterial(ID, materialNm, hsn, mtype, mqty, size, ptype, packetqty);
            }
            setTimeout(() => {
                setFormData({
                    ...formData,
                    cloth: ''
                });
            }, 1000);
        }

    };
    const handleDateChange = (e) => {
        setFormData({
            ...formData,
            dt: e.target.value
        });
    };

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormData({
            ...formData,
            [name]: value.toUpperCase()
        });
    };

    const handleRowInputChange = (index, e) => {
        const { name, value } = e.target;

        const newRows = [...tableRows];
        newRows[index][name] = value;
        // console.log(name, value)
        if (name === 'rate' || name === 'qty' || name === 'amount' || name === 'IGST' ||
            name === 'IGSTAmt' || name === 'CGST' || name === 'CGSTAmt' || name === 'SGST' ||
            name === 'SGSTAmt') {
            if (!/^\d*$/.test(value)) {
                return;
            }
        }
        // Calculate amount if 'rate' or 'meter' changes
        // Calculate IGSTAmt based on state_type and IGST percentage

        // state type =
        //  inside - 0
        // outside - 1
        if (formData.vender !== '') {
            if (name === 'rate' || name === 'qty' || name === 'packets' || name === 'packetqty') {
                const rate = parseFloat(newRows[index]['rate']) || 0;
                const qty = parseFloat(newRows[index]['qty']) || 0;
                const packets = parseFloat(newRows[index]['packets']) || 0;
                const packetqty = parseFloat(newRows[index]['packetqty']) || 0;

                // Calculate CGST and SGST amounts based on amount
                const amount = parseFloat(newRows[index]['amount']) || 0;
                const CGSTPercent = parseFloat(newRows[index]['CGST']) || 0;
                const SGSTPercent = parseFloat(newRows[index]['SGST']) || 0;
                newRows[index]['CGSTAmt'] = ((amount * CGSTPercent) / 100).toFixed(2);
                newRows[index]['SGSTAmt'] = ((amount * SGSTPercent) / 100).toFixed(2);
                const mtype = newRows[index]['mtype'];


                if (mtype === "Pcs") {
                    newRows[index]['inches'] = 0;
                    newRows[index]['mtr'] = 0;

                    const singlebox = (packets * packetqty).toFixed(2);

                    newRows[index]['totboxqty'] = (qty * singlebox).toFixed(2);
                    newRows[index]['amount'] = (rate * qty).toFixed(2);
                }

                if (mtype === "Mtr") {
                    const inches = 39.3701; // 1mtr
                    const singleMtr = (packets * packetqty).toFixed(2);
                    const totmtr = (singleMtr * qty).toFixed(2);
                    newRows[index]['mtr'] = totmtr;
                    newRows[index]['inches'] = (totmtr * inches).toFixed(2);
                    newRows[index]['amount'] = (rate * qty).toFixed(2);
                    newRows[index]['totboxqty'] = 0;
                }

                if (mtype === "Inch") {
                    const inches = 39.3701; // 1mtr
                    const singleInchM = (packets * packetqty).toFixed(2);
                    const totinches = (singleInchM * qty).toFixed(2);
                    newRows[index]['inches'] = totinches;
                    newRows[index]['mtr'] = (totinches / inches).toFixed(2);
                    newRows[index]['amount'] = (rate * qty).toFixed(2);
                    newRows[index]['totboxqty'] = 0;
                }
            }
            const stateType = partyList.data.length > 0 ? partyList.data.find((item) => item.ID === formData.vender) : '';

            if (stateType.state_type === '1' || name === 'IGST' || name === 'amount') {
                const amount = parseFloat(newRows[index]['amount']) || 0;
                const IGSTPercent = parseFloat(newRows[index]['IGST']) || 0;
                newRows[index]['IGSTAmt'] = ((amount * IGSTPercent) / 100).toFixed(2);
                newRows[index]['CGSTAmt'] = '0';
                newRows[index]['SGSTAmt'] = '0';

                var totalTaxAmt = newRows.reduce((total, row) => total + parseFloat(row.IGSTAmt || 0), 0);
            }

            if (stateType.state_type === '0' || name === 'amount' || name === 'CGST' || name === 'SGST') {
                const amount = parseFloat(newRows[index]['amount']) || 0;
                const CGSTPercent = parseFloat(newRows[index]['CGST']) || 0;
                const SGSTPercent = parseFloat(newRows[index]['SGST']) || 0;

                newRows[index]['CGSTAmt'] = ((amount * CGSTPercent) / 100).toFixed(2);
                newRows[index]['SGSTAmt'] = ((amount * SGSTPercent) / 100).toFixed(2);
                newRows[index]['IGSTAmt'] = '0';

                var cgst1 = newRows.reduce((total, row) => total + parseFloat(row.CGSTAmt || 0), 0);
                var sgst1 = newRows.reduce((total, row) => total + parseFloat(row.SGSTAmt || 0), 0);
                var totalTaxAmt = cgst1 + sgst1;
            }
            if (name === 'amount' || name === 'CGST' || name === 'SGST') {
                const amount = parseFloat(newRows[index]['amount']) || 0;
                const CGSTPercent = parseFloat(newRows[index]['CGST']) || 0;
                const SGSTPercent = parseFloat(newRows[index]['SGST']) || 0;

                newRows[index]['CGSTAmt'] = ((amount * CGSTPercent) / 100).toFixed(2);
                newRows[index]['SGSTAmt'] = ((amount * SGSTPercent) / 100).toFixed(2);
                newRows[index]['IGSTAmt'] = '0';

                var cgst = newRows.reduce((total, row) => total + parseFloat(row.CGSTAmt || 0), 0);
                var sgst = newRows.reduce((total, row) => total + parseFloat(row.SGSTAmt || 0), 0);
                var totalTaxAmt = cgst + sgst;
            }

            if (name === 'IGST') {
                // console.log(value);
                const amount = parseFloat(newRows[index]['amount']) || 0;
                const percentage = parseFloat(value);
                newRows[index]['IGST'] = percentage;

                if (stateType.state_type === '0') {
                    const halfPer = percentage / 2;
                    newRows[index]['CGST'] = halfPer;
                    newRows[index]['SGST'] = halfPer;

                    newRows[index]['CGSTAmt'] = ((amount * halfPer) / 100).toFixed(2);
                    newRows[index]['SGSTAmt'] = ((amount * halfPer) / 100).toFixed(2);
                    newRows[index]['IGSTAmt'] = '0';

                    var cgst = newRows.reduce((total, row) => total + parseFloat(row.CGSTAmt || 0), 0);
                    var sgst = newRows.reduce((total, row) => total + parseFloat(row.SGSTAmt || 0), 0);
                    var totalTaxAmt = cgst + sgst;
                } else {
                    newRows[index]['IGSTAmt'] = ((amount * percentage) / 100).toFixed(2);
                    newRows[index]['CGSTAmt'] = '0';
                    newRows[index]['SGSTAmt'] = '0';

                    var totalTaxAmt = newRows.reduce((total, row) => total + parseFloat(row.IGSTAmt || 0), 0);
                }
            }

            const totalMeter = newRows.reduce((total, row) => total + parseFloat(row.mtr || 0), 0);
            const totqty = newRows.reduce((total, row) => total + parseFloat(row.totboxqty || 0), 0);
            const totalAmount = newRows.reduce((total, row) => total + parseFloat(row.amount || 0), 0);
            const finalAmt = totalTaxAmt + totalAmount;

            const updatedFormData = {
                ...formData,
                amt: totalAmount.toFixed(2),
                totmtr: totalMeter.toFixed(2),
                totqty: totqty.toFixed(2),
                taxAmt: totalTaxAmt.toFixed(2),
                fAmt: finalAmt.toFixed(2)
            };

            // Update tableRows state
            setTableRows(newRows);
            // Update formData state
            setFormData(updatedFormData);
        } else {
            alert("Purchase Party Is required.");
        }
    };


    const debouncedHandleChange = (index, e) => {
        const { name, value } = e.target;
        handleRowInputChange(index, name, value);
    };

    const handleAddRow = (clothNm, uom, hsn, value, color, model, panna_size, shadeNo) => {
        const newRow = {
            clothId: value,
            cloth: `${clothNm} ${model} ${color} ${shadeNo} ${panna_size}`,
            hsn: hsn,
            unit: uom,
            deliveryDate: '',
            rate: '0',
            meter: '0',
            amount: '0',
            IGST: '5',
            IGSTAmt: '0',
            CGST: '2.5',
            CGSTAmt: '0',
            SGST: '2.5',
            SGSTAmt: '0'
        };
        setTableRows([...tableRows, newRow]);
    };

    const handleAddMaterial = (ID, materialNm, hsn, mtype, mqty, size, ptype, packetqty) => {

        const newRow = {
            matId: ID,
            materialNm: materialNm,
            size: size,
            hsn: hsn,
            packets: packetqty,
            mtype: mtype,
            ptype: ptype,
            packetqty: mqty,
            deliveryDate: '',
            inches: '',
            mtr: '0',
            totboxqty: 0,
            qty: '0',
            rate: '0',
            amount: '0',
            IGST: '5',
            IGSTAmt: '0',
            CGST: '2.5',
            CGSTAmt: '0',
            SGST: '2.5',
            SGSTAmt: '0'
        };
        setTableRows([...tableRows, newRow]);
    };

    function convertIntoOneObject(array, formData) {
        const tableData = {
            array: array,
            // Include formData fields

            partyId: formData.vender,
            pono: formData.PoNo,
            ordt: formData.ordt,
            firm: formData.firm,
            totqty: formData.totqty,
            totmtr: formData.totmtr,
            amt: formData.amt,
            taxAmt: formData.taxAmt,
            fAmt: formData.fAmt,
            shftTo: formData.shftTo,
            ref: formData.ref,
            userId: formData.userId
        };
        return tableData;
    };

    const handleCheckboxChange = (index) => {
        setSelectedRows((prevSelectedRows) => {
            if (prevSelectedRows.includes(index)) {
                return prevSelectedRows.filter((rowIndex) => rowIndex !== index);
            } else {
                return [...prevSelectedRows, index];
            }
        });
    };

    const handleDeleteRows = () => {
        const updated = tableRows?.filter((_, index) => !selectedRows.includes(index));
        const totalMeter = updated.reduce((total, row) => total + parseFloat(row.mtr || 0), 0);
        const totqty = updated.reduce((total, row) => total + parseFloat(row.totboxqty || 0), 0);
        const totalAmount = updated.reduce((total, row) => total + parseFloat(row.amount || 0), 0);
        const igstamt = updated.reduce((total, row) => total + parseFloat(row.IGSTAmt || 0), 0);
        const cgstamt = updated.reduce((total, row) => total + parseFloat(row.CGSTAmt || 0), 0);
        const sgstamt = updated.reduce((total, row) => total + parseFloat(row.SGSTAmt || 0), 0);
        const taxamt = igstamt + cgstamt + sgstamt;
        const finalAmt = taxamt + totalAmount;

        const updatedFormData = {
            ...formData,
            amt: totalAmount.toFixed(2),
            totmtr: totalMeter.toFixed(2),
            totqty: totqty.toFixed(2),
            taxAmt: taxamt.toFixed(2),
            fAmt: finalAmt.toFixed(2)
        };
        setTableRows(updated);
        setSelectedRows([]);
        setFormData(updatedFormData);
    };

    const handleDropdownOpen = (dropdown) => {
        setOpenDropdowns((prev) => ({ ...prev, [dropdown]: true }));
    };

    const handleDropdownClose = (dropdown) => {
        setOpenDropdowns((prev) => ({ ...prev, [dropdown]: false }));
    };

    const handleNavigateCloth = () => {
        window.open(`/new-material-entry`, '_blank', 'width=800,height=600,scrollbars=yes,resizable=yes');
    };

    const handleNavigateParty = () => {
        window.open(`/NewPartyEntry`, '_blank', 'width=800,height=600,scrollbars=yes,resizable=yes');
    };
    // console.log(materialData);
    const dropdownlistfirst = [
        {
            label: 'Material',
            id: 'matId',
            options: materialData || [],
            value: formData.matId,
            onChange: (newValue) => handleDropdownChange({ target: { name: 'matId', value: newValue ? newValue.ID : '' } }, 'matId'),
            getOptionLabel: (option) => option.materialNm || '',
            isOptionEqualToValue: (option, value) => option.ID === value.ID,
            valueFinder: (options, value) => {
                if (Array.isArray(options)) {
                    return options.find(item => item.ID === value) || null;
                }
                return null;
            },
            handleAddNew: () => handleNavigateCloth(),
            btnlabel: 'New',
            handleDropdownOpen: () => handleDropdownOpen('matId'),
            handleDropdownClose: () => handleDropdownClose('matId'),
        },
        {
            label: 'Purchase Party',
            id: 'vender',
            options: partyList?.data || [],
            value: formData.vender,
            onChange: (newValue) => handleDropdownChange({ target: { name: 'vender', value: newValue ? newValue.ID : '' } }, 'vender'),
            getOptionLabel: (option) => option.partyNm || '',
            isOptionEqualToValue: (option, value) => option.ID === value.ID,
            valueFinder: (options, value) => {
                if (Array.isArray(options)) {
                    return options.find(item => item.ID === value) || null;
                }
                return null;
            },
            handleAddNew: () => handleNavigateParty(),
            btnlabel: 'New',
            handleDropdownOpen: () => handleDropdownOpen('vender'),
            handleDropdownClose: () => handleDropdownClose('vender'),
        }
    ];

    const dropdownlistsecond = [
        {
            label: 'Firm',
            id: 'firm',
            options: firmList?.data,
            value: formData.firm,
            onChange: (newValue) => handleDropdownChange({ target: { name: 'firm', value: newValue ? newValue.ID : '' } }, 'firm'),
            getOptionLabel: (option) => option.firmNm || '',
            isOptionEqualToValue: (option, value) => option.ID === value.ID,
            valueFinder: (options, value) => {
                if (Array.isArray(options)) {
                    return options.find(item => item.ID === value) || null;
                }
                return null;
            },
        }
    ];
    // console.log(clothList)

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);


        try {
            let finalObject = convertIntoOneObject(tableRows, formData);
            // console.log(finalObject);

            const result = await axios.post(`${baseUrl}?apicall=insertMaterialPOEntry`, finalObject);
            // console.log(result.data);
            const data = result?.data;
            if (data.status === "success") {
                alert(data.msg);
                window.location.reload();
            } else {
                const msg = Array.isArray(data.msg) ? data.msg.join("\n") : data.msg;
                alert(msg);
            }
        } catch (error) {
            console.error('Error while making POST request:', error);
        } finally {
            setLoading(false);
        }


    };

    return (
        <>
            <Titlebar data={materialPOMenu} />
            <div style={{ margin: '1% 0.5%' }}>
                <h2>Material Purchase Order Entry</h2>
                <Grid container spacing={2}>
                    <Grid item xs={12}>
                        <Paper style={{ padding: '2vh' }}>
                            <Grid container spacing={0.5}>

                                {/* <Grid item xs={12} md={6}>
                                    <Grid container alignItems="center" spacing={1}>
                                        <Grid item style={isDesktop ? { width: '30%' } : { width: '100%' }}>
                                            <InputLabel id="cloth">Cloth:</InputLabel>
                                        </Grid>
                                        <Grid item xs>
                                            <FormControl fullWidth >
                                                <Select
                                                    labelId="cloth"
                                                    id="cloth"
                                                    name="cloth"
                                                    value={formData.cloth}
                                                    onChange={(e) => handleDropdownChange(e, 'cloth')}
                                                    sx={inputStyles}
                                                >
                                                    <MenuItem value="">Select an option</MenuItem>
                                                    {
                                                        clothList ? clothList.data.map((item, index) => (
                                                            <MenuItem key={index} value={item.ID}>{item.clothNm} {item.model} {item.color} {item.shadeNo} {item.panna_size}</MenuItem>
                                                        )) : []
                                                    }
                                                </Select>
                                            </FormControl>
                                        </Grid>
                                    </Grid>
                                </Grid> */}

                                {
                                    dropdownlistfirst && dropdownlistfirst.map((drop) => (
                                        <DropdownWithBtn
                                            key={drop.label}
                                            label={drop.label}
                                            id={drop.id}
                                            options={drop.options}
                                            value={drop.value}
                                            onChange={drop.onChange}
                                            isDesktop={isDesktop}
                                            getOptionLabel={drop.getOptionLabel}
                                            isOptionEqualToValue={drop.isOptionEqualToValue}
                                            valueFinder={drop.valueFinder}  // Pass `valueFinder` function here
                                            handleAddNew={drop.handleAddNew}
                                            btnlabel={drop.btnlabel}
                                            handleDropdownOpen={drop.handleDropdownOpen}
                                            handleDropdownClose={drop.handleDropdownClose}
                                        />
                                    ))
                                }

                                {/* <Grid item xs={12} md={6}>
                                    <Grid container alignItems="center" spacing={1}>
                                        <Grid item style={isDesktop ? { width: '30%' } : { width: '100%' }}>
                                            <InputLabel id="vender">Purchase Party:</InputLabel>
                                        </Grid>
                                        <Grid item xs>
                                            <FormControl fullWidth >
                                                <Select
                                                    labelId="vender"
                                                    id="vender"
                                                    name="vender"
                                                    value={formData.vender}
                                                    onChange={(e) => handleDropdownChange(e, 'vender')}
                                                    sx={inputStyles}
                                                >
                                                    <MenuItem value="">Select an option</MenuItem>
                                                    {
                                                        partyList ? partyList.data.map((item, index) => (
                                                            <MenuItem key={index} value={item.ID}>{item.partyNm}</MenuItem>
                                                        )) : []
                                                    }
                                                </Select>
                                            </FormControl>
                                        </Grid>
                                    </Grid>
                                </Grid> */}

                                {[
                                    { label: 'PO No', name: 'PoNo' },
                                    { label: 'Date', name: 'ordt', type: 'date' }

                                ].map((field, index) => (
                                    <Grid item xs={12} md={6} key={index}>
                                        <Grid container alignItems="center" spacing={1}>
                                            <Grid item style={isDesktop ? { width: '30%' } : { width: '100%' }}>
                                                <InputLabel htmlFor={field.name} >{field.label}:</InputLabel>
                                            </Grid>
                                            <Grid item xs>
                                                <FormControl fullWidth>
                                                    {field.type === 'date' ? (
                                                        <TextField
                                                            id={field.name}
                                                            name={field.name}
                                                            type="date"
                                                            value={formData[field.name]}
                                                            onChange={handleDateChange}
                                                            inputProps={{ style: styled.inputDate }}
                                                            sx={inputStyles}
                                                        />
                                                    ) : (
                                                        <TextField
                                                            id={field.name}
                                                            name={field.name}
                                                            value={formData[field.name]}
                                                            onChange={handleInputChange}
                                                            inputProps={{ style: styled.input, readOnly: field.name == 'PoNo' }}
                                                            sx={inputStyles}
                                                        />
                                                    )}
                                                </FormControl>
                                            </Grid>
                                        </Grid>
                                    </Grid>
                                ))}

                                {/* <Grid item xs={12} md={6}>
                                    <Grid container alignItems="center" spacing={1}>
                                        <Grid item style={isDesktop ? { width: '30%' } : { width: '100%' }}>
                                            <InputLabel id="firm">Firm :</InputLabel>
                                        </Grid>
                                        <Grid item xs>
                                            <FormControl fullWidth >
                                                <Select
                                                    labelId="firm"
                                                    id="firm"
                                                    name="firm"
                                                    value={formData.firm}
                                                    onChange={(e) => handleDropdownChange(e, 'firm')}
                                                    sx={inputStyles}
                                                >
                                                    <MenuItem value="">Select an option</MenuItem>
                                                    {
                                                        firmList ? firmList.data.map((item, index) => (
                                                            <MenuItem key={index} value={item.ID}>{item.firmNm}</MenuItem>
                                                        )) : []
                                                    }
                                                </Select>
                                            </FormControl>
                                        </Grid>
                                    </Grid>
                                </Grid> */}

                                {
                                    dropdownlistsecond && dropdownlistsecond.map((drop) => (
                                        <Dropdown
                                            key={drop.label}
                                            label={drop.label}
                                            id={drop.id}
                                            options={drop.options}
                                            value={drop.value}
                                            onChange={drop.onChange}
                                            isDesktop={isDesktop}
                                            getOptionLabel={drop.getOptionLabel}
                                            isOptionEqualToValue={drop.isOptionEqualToValue}
                                            valueFinder={drop.valueFinder}  // Pass `valueFinder` function here
                                        />
                                    ))
                                }

                                {[
                                    { label: 'Total Qty.', name: 'totqty', type: 'readOnly' },
                                    { label: 'Total Mtr.', name: 'totmtr', type: 'readOnly' },
                                    { label: 'Amount', name: 'amt', type: 'readOnly' },
                                    { label: 'Tax Amount', name: 'taxAmt', type: 'readOnly' },
                                    { label: 'Final Amount', name: 'fAmt', type: 'readOnly' },
                                ].map((field, index) => (
                                    <Grid item xs={12} md={6} key={index}>
                                        <Grid container alignItems="center" spacing={1}>
                                            <Grid item style={isDesktop ? { width: '30%' } : { width: '100%' }}>
                                                <InputLabel htmlFor={field.name}>{field.label}:</InputLabel>
                                            </Grid>
                                            <Grid item xs>
                                                <FormControl fullWidth>
                                                    <TextField
                                                        id={field.name}
                                                        name={field.name}
                                                        value={formData[field.name] || ''}
                                                        onChange={handleInputChange}
                                                        inputProps={{ style: styled.input, readOnly: field.type === 'readOnly' }}
                                                        sx={inputStyles}
                                                    />
                                                </FormControl>
                                            </Grid>
                                        </Grid>
                                    </Grid>
                                ))}



                                {[
                                    { label: 'Shift to', name: 'shftTo' },
                                    { label: 'Reference', name: 'ref' },
                                ].map((field, index) => (
                                    <Grid item xs={12} md={6} key={index}>
                                        <Grid container alignItems="center" spacing={1}>
                                            <Grid item style={isDesktop ? { width: '30%' } : { width: '100%' }}>
                                                <InputLabel htmlFor={field.name}>{field.label}:</InputLabel>
                                            </Grid>
                                            <Grid item xs>
                                                <FormControl fullWidth>
                                                    <TextareaAutosize
                                                        id={field.name}
                                                        name={field.name}
                                                        value={formData[field.name]}
                                                        onChange={handleInputChange}
                                                        style={{ width: '80%', height: '100px', padding: '5px', borderRadius: '4px', border: '1px solid #000', ...styled.input }}
                                                    />
                                                </FormControl>
                                            </Grid>
                                        </Grid>
                                    </Grid>
                                ))}



                                <Grid item xs={12}>
                                    <Button variant="contained" color="secondary" onClick={handleDeleteRows} disabled={selectedRows.length === 0}>Delete</Button>
                                </Grid>
                                <Grid item xs={12}>
                                    <div>
                                        <TableContainer width={400}>
                                            <Table>
                                                <TableHead>
                                                    <TableRow>
                                                        <TableCell className='th4' sx={{ p: 0.4, border: '1px solid #000' }} align='center'>Sr.No.</TableCell>
                                                        <TableCell className='th4' sx={{ p: 0.4, border: '1px solid #000' }} align='center'>Material</TableCell>
                                                        <TableCell className='th4' sx={{ p: 0.4, border: '1px solid #000' }} align='center'>Size</TableCell>
                                                        <TableCell className='th4' sx={{ p: 0.4, border: '1px solid #000' }} align='center'>HSN</TableCell>
                                                        <TableCell className='th4' sx={{ p: 0.4, border: '1px solid #000' }} align='center'>M.Qty & Type</TableCell>
                                                        <TableCell className='th4' sx={{ p: 0.2, border: '1px solid #000' }} align='center'>P.P Qty/Mtr & Type</TableCell>
                                                        <TableCell className='th4' sx={{ p: 0.4, border: '1px solid #000' }} align='center'>Delivery Date</TableCell>
                                                        <TableCell className='th4' sx={{ p: 0.4, border: '1px solid #000' }} align='center'>Rate</TableCell>
                                                        <TableCell className='th4' sx={{ p: 0.4, border: '1px solid #000' }} align='center'>Qty.</TableCell>
                                                        <TableCell className='th4' sx={{ p: 0.4, border: '1px solid #000' }} align='center'>Mtr.</TableCell>
                                                        <TableCell className='th4' sx={{ p: 0.4, border: '1px solid #000' }} align='center'>Inches</TableCell>
                                                        <TableCell className='th4' sx={{ p: 0.4, border: '1px solid #000' }} align='center'>Total Qty.</TableCell>
                                                        <TableCell className='th4' sx={{ p: 0.4, border: '1px solid #000' }} align='center'>Amount</TableCell>
                                                        <TableCell className='th4' sx={{ p: 0.4, border: '1px solid #000' }} align='center'>IGST(%)</TableCell>
                                                        <TableCell className='th4' sx={{ p: 0.4, border: '1px solid #000' }} align='center'>IGSTAmt</TableCell>
                                                        <TableCell className='th4' sx={{ p: 0.4, border: '1px solid #000' }} align='center'>CGST(%)</TableCell>
                                                        <TableCell className='th4' sx={{ p: 0.4, border: '1px solid #000' }} align='center'>CGSTAmt</TableCell>
                                                        <TableCell className='th4' sx={{ p: 0.4, border: '1px solid #000' }} align='center'>SGST(%)</TableCell>
                                                        <TableCell className='th4' sx={{ p: 0.4, border: '1px solid #000' }} align='center'>SGSTAmt</TableCell>
                                                    </TableRow>
                                                </TableHead>
                                                <TableBody>
                                                    {tableRows?.map((row, index) => {
                                                        {/* const isEditable = ['Mtr', 'Inch'].includes(row.mtype);
                                                        const isqtyEditable = ['Pcs', 'Box', 'Roll'].includes(row.mtype); */}

                                                        return (

                                                            <TableRow key={index}>
                                                                <TableCell sx={{ p: 0.4, border: '1px solid #000' }} align='center'>
                                                                    <Checkbox
                                                                        checked={selectedRows.includes(index)}
                                                                        onChange={() => handleCheckboxChange(index)}
                                                                    />
                                                                    {index + 1}
                                                                </TableCell>
                                                                <TableCell sx={{ p: 0.4, border: '1px solid #000' }} align='center'>
                                                                    {row.materialNm}
                                                                </TableCell>
                                                                <TableCell sx={{ p: 0.4, border: '1px solid #000' }} align='center'>
                                                                    {row.size}
                                                                </TableCell>
                                                                <TableCell sx={{ p: 0.4, border: '1px solid #000' }} align='center'>
                                                                    {row.hsn}
                                                                </TableCell>
                                                                <TableCell sx={{ p: 0.4, border: '1px solid #000' }} align='center'>

                                                                    <input
                                                                        type='text'
                                                                        name="packetqty"
                                                                        value={row.packetqty}
                                                                        onChange={(e) => handleRowInputChange(index, e)}
                                                                        style={{ width: '50px', padding: '1px' }}
                                                                    />

                                                                    {" "}{row.mtype}
                                                                </TableCell>
                                                                <TableCell sx={{ p: 0.2, border: '1px solid #000' }} align='center'>

                                                                    <input
                                                                        type='text'
                                                                        name="packets"
                                                                        value={row.packets}
                                                                        onChange={(e) => handleRowInputChange(index, e)}
                                                                        style={{ width: '50px', padding: '1px' }}
                                                                    />
                                                                    {" "} {row.ptype}
                                                                </TableCell>
                                                                <TableCell sx={{ p: 0.4, border: '1px solid #000' }} align='center'>
                                                                    <input
                                                                        type="date"
                                                                        name="deliveryDate"
                                                                        value={row.deliveryDate}
                                                                        onChange={(e) => handleRowInputChange(index, e)}
                                                                        style={{ width: '100px', padding: '1px' }}
                                                                    />
                                                                </TableCell>
                                                                <TableCell sx={{ p: 0.4, border: '1px solid #000' }} align='center'>
                                                                    <input
                                                                        type='text'
                                                                        name="rate"
                                                                        value={row.rate}
                                                                        onChange={(e) => handleRowInputChange(index, e)}
                                                                        style={{ width: '50px', padding: '1px' }}
                                                                    />
                                                                </TableCell>
                                                                <TableCell sx={{ p: 0.4, border: '1px solid #000' }} align='center'>
                                                                    <input
                                                                        type='text'
                                                                        name="qty"
                                                                        value={row.qty}
                                                                        // readOnly={!isqtyEditable}
                                                                        onChange={(e) => handleRowInputChange(index, e)}
                                                                        style={{ width: '50px', padding: '1px' }}
                                                                    />
                                                                </TableCell>
                                                                <TableCell sx={{ p: 0.4, border: '1px solid #000' }} align='center'>
                                                                    {/* <input
                                                                        type='text'
                                                                        name="mtr"
                                                                        value={row.mtr}
                                                                        // readOnly={!isEditable}
                                                                        readOnly
                                                                        onChange={(e) => handleRowInputChange(index, e)}
                                                                        style={{ width: '50px', padding: '1px' }}
                                                                    /> */}

                                                                    {row.mtr}
                                                                </TableCell>

                                                                <TableCell sx={{ p: 0.4, border: '1px solid #000' }} align='center'>
                                                                    {row.inches}
                                                                </TableCell>
                                                                <TableCell sx={{ p: 0.4, border: '1px solid #000' }} align='center'>
                                                                    {row.totboxqty}
                                                                </TableCell>
                                                                <TableCell sx={{ p: 0.4, border: '1px solid #000' }} align='center'>
                                                                    {/* <input
                                                                        type='text'
                                                                        name="amount"
                                                                        value={row.amount}
                                                                        onChange={(e) => handleRowInputChange(index, e)}
                                                                        style={{ width: '50px', padding: '1px' }}
                                                                    /> */}
                                                                    {row.amount}
                                                                </TableCell>

                                                                <TableCell sx={{ p: 0.4, border: '1px solid #000' }} align='center'>
                                                                    {/* <input
                                                                    type='text'
                                                                    name="IGST"
                                                                    value={row.IGST}
                                                                    onChange={(e) => handleRowInputChange(index, e)}
                                                                    style={{ width: '50px', padding: '1px' }}
                                                                /> */}
                                                                    {/* onChange={(e) => setValue(e.target.value)} */}

                                                                    <select name="IGST" value={row.IGST} onChange={(e) => handleRowInputChange(index, e)}>
                                                                        <option value="5">5</option>
                                                                        <option value="12">12</option>
                                                                        <option value="18">18</option>
                                                                    </select>
                                                                </TableCell>
                                                                <TableCell sx={{ p: 0.4, border: '1px solid #000' }} align='center'>
                                                                    {/* <input
                                                                        type='text'
                                                                        name="IGSTAmt"
                                                                        value={row.IGSTAmt}
                                                                        onChange={(e) => handleRowInputChange(index, e)}
                                                                        style={{ width: '50px', padding: '1px' }}
                                                                        readOnly
                                                                    /> */}
                                                                    {row.IGSTAmt}
                                                                </TableCell>
                                                                <TableCell sx={{ p: 0.4, border: '1px solid #000' }} align='center'>

                                                                    {/* <input
                                                                        type='text'
                                                                        name="CGST"
                                                                        value={row.CGST}
                                                                        onChange={(e) => handleRowInputChange(index, e)}
                                                                        style={{ width: '50px', padding: '1px' }}
                                                                        readOnly
                                                                    /> */}
                                                                    {row.CGST}
                                                                </TableCell>
                                                                <TableCell sx={{ p: 0.4, border: '1px solid #000' }} align='center'>

                                                                    {/* <input
                                                                        type='text'
                                                                        name="CGSTAmt"
                                                                        value={row.CGSTAmt}
                                                                        onChange={(e) => handleRowInputChange(index, e)}
                                                                        style={{ width: '50px', padding: '1px' }}
                                                                        readOnly
                                                                    /> */}
                                                                    {row.CGSTAmt}
                                                                </TableCell>
                                                                <TableCell sx={{ p: 0.4, border: '1px solid #000' }} align='center'>

                                                                    {/* <input
                                                                        type='text'
                                                                        name="SGST"
                                                                        value={row.SGST}
                                                                        onChange={(e) => handleRowInputChange(index, e)}
                                                                        style={{ width: '50px', padding: '1px' }}
                                                                        readOnly
                                                                    /> */}
                                                                    {row.SGST}
                                                                </TableCell>
                                                                <TableCell sx={{ p: 0.4, border: '1px solid #000' }} align='center'>

                                                                    {/* <input
                                                                        type='text'
                                                                        name="SGSTAmt"
                                                                        value={row.SGSTAmt}
                                                                        onChange={(e) => handleRowInputChange(index, e)}
                                                                        style={{ width: '50px', padding: '1px' }}
                                                                        readOnly
                                                                    /> */}
                                                                    {row.SGSTAmt}
                                                                </TableCell>
                                                            </TableRow>
                                                        )
                                                    }
                                                    )}
                                                </TableBody>
                                            </Table>
                                        </TableContainer>
                                    </div>
                                </Grid>

                                {tableRows?.length > 0 &&
                                    (<Grid item xs={12} textAlign="center">
                                        <Button variant="contained" color="primary" onClick={handleSubmit} disabled={loading === true}>
                                            {
                                                loading === true ?
                                                    <><CircularProgress size="20px" /> wait...</> :
                                                    "Submit"
                                            }
                                        </Button>
                                    </Grid>)}

                            </Grid>
                            <ToastContainer />
                        </Paper>
                    </Grid>
                </Grid>
            </div>
        </>
    );
}

export default MaterialPOEntry;
